import { render } from "./M423_Horn.vue?vue&type=template&id=2d39b460&scoped=true"
import script from "./M423_Horn.vue?vue&type=script&lang=js"
export * from "./M423_Horn.vue?vue&type=script&lang=js"

import "./M423_Horn.vue?vue&type=style&index=0&id=2d39b460&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d39b460"]])

export default __exports__